/**
 * Product benefit rows + modal (DJI-style).
 */
(function () {
  'use strict';

  function openModal(dialog, trigger) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeModal(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    const trigger = document.querySelector('[aria-controls="' + dialog.id + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function initBenefitModals(root) {
    root.querySelectorAll('.product-benefit__trigger[aria-controls]').forEach((trigger) => {
      if (trigger.dataset.benefitBound) return;
      trigger.dataset.benefitBound = 'true';

      const dialogId = trigger.getAttribute('aria-controls');
      const dialog = document.getElementById(dialogId);
      if (!dialog) return;

      trigger.addEventListener('click', () => openModal(dialog, trigger));

      dialog.querySelectorAll('[data-benefit-close]').forEach((btn) => {
        btn.addEventListener('click', () => closeModal(dialog));
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeModal(dialog);
      });

      dialog.addEventListener('close', () => {
        trigger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function init(root) {
    initBenefitModals(root || document);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));

  document.addEventListener('product:rerender', () => {
    init(document);
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const dialog = event.target.querySelector('.product-benefit-modal');
      if (dialog) openModal(dialog);
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const dialog = event.target.querySelector('.product-benefit-modal');
      if (dialog) closeModal(dialog);
    });
  }
})();
